import { CiFacebook, CiInstagram } from "react-icons/ci";
import { Link } from "react-router-dom";

function Footer() {
    return (
        <div className="flex flex-col items-center justify-center w-full h-full text-center text-white bg-black opacity-90 font-manrope">
            <h2 className="mt-10 text-2xl font-bold uppercase md:text-4xl">
                Site Links
            </h2>

            <div className="flex flex-col w-5/6 mt-5 text-xl md:justify-center md:space-x-4 md:flex-row ">
                <Link
                    to="/"
                    className="hover:text-yellow-100 hover:underline"
                    onClick={() => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                        });
                    }}
                >
                    Home
                </Link>
                <Link
                    to="/menu"
                    className="hover:text-yellow-100 hover:underline"
                    onClick={() => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                        });
                    }}
                >
                    Menu
                </Link>
                <Link
                    to="/drinks"
                    className="hover:text-yellow-100 hover:underline"
                    onClick={() => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                        });
                    }}
                >
                    Drinks
                </Link>
                <Link
                    to="/contact"
                    className="hover:text-yellow-100 hover:underline"
                    onClick={() => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                        });
                    }}
                >
                    Contact
                </Link>
            </div>

            <span className="md:w-4/6 w-5/6 p-[0.5px] mt-10 bg-white"></span>

            <h2 className="mt-10 text-2xl font-bold uppercase md:text-4xl">
                Location
            </h2>
            <p className="text-xl font-bold uppercase mt-7">Lubbock</p>
            <p className="px-5 mt-3 text-base md:text-lg">
                1910 Quaker Ave #106, Lubbock, TX 79407
            </p>

            <div className="inline-flex items-center justify-center w-full mt-5">
                <hr className="w-4/6 h-px my-8 bg-white border-0 md:w-2/6" />
                <span className="absolute px-3 text-lg font-bold text-white -translate-x-1/2 bg-black opacity-95 left-1/2">
                    Service Hours
                </span>
            </div>

            <div className="flex flex-col">
                <div className="flex flex-row justify-between">
                    <p>Monday</p>
                    <p>11 AM - 10 PM</p>
                </div>
                <div className="flex flex-row justify-between">
                    <p>Tuesday</p>
                    <p>11 AM - 10 PM</p>
                </div>
                <div className="flex flex-row justify-between space-x-4">
                    <p>Wednesday</p>
                    <p>11 AM - 10 PM</p>
                </div>
                <div className="flex flex-row justify-between ">
                    <p>Thursday</p>
                    <p>11 AM - 10 PM</p>
                </div>
                <div className="flex flex-row justify-between ">
                    <p>Friday</p>
                    <p>10 AM - 10 PM</p>
                </div>
                <div className="flex flex-row justify-between ">
                    <p>Saturday</p>
                    <p>11 AM - 10 PM</p>
                </div>
                <div className="flex flex-row justify-between ">
                    <p>Sunday</p>
                    <p>10 AM - 9 PM</p>
                </div>
            </div>

            <span className="w-5/6 md:w-4/6 p-[0.5px] mt-10 bg-white"></span>

            <div className="flex flex-row items-center justify-center mt-20 space-x-5 text-black">
                <a
                    href="https://www.facebook.com/phodistrict106"
                    target="_blank"
                >
                    <CiFacebook
                        size="50px"
                        className="p-1 bg-white rounded-full hover:bg-yellow-100"
                    />
                </a>
                <a
                    href="https://www.instagram.com/phodistrictt1_/"
                    target="_blank"
                >
                    <CiInstagram
                        size="50px"
                        className="p-1 bg-white rounded-full hover:bg-yellow-100"
                    />
                </a>
            </div>

            <div className="mt-24">
                © 2023 Pho District 1. All Rights Reserved.
            </div>
            <div className="pb-24"></div>
        </div>
    );
}

export default Footer;
